<template>
  <div class="product-tj-page">

    <van-nav-bar left-arrow fixed title="特价商品" id="nav-bar" @click-left="onClickLeft">
    </van-nav-bar>

    <div class="list">
      <van-list style="display: flex; flex-wrap:wrap;" v-model="loading" :finished="finished" finished-text="没有更多了" @load="getProductList">
        <img-text-row :product="item" v-for="(item, index) in productList" :key="index"></img-text-row>
      </van-list>
    </div>

  </div>
</template>
  
  <script>
import imgTextRow from "@/components/img-text-tj-block/img-text-tj-block.vue";

export default {
  name: "likeList",
  components: { imgTextRow },
  props: {},
  data() {
    return {
      bigCatalogId: "", //底部分类ID
      productList: [], //商品
      pageNum: 1,
      pageSize: 20,
      loading: true,
      finished: false,
    };
  },
  watch: {
    aa: {
      handler(newValue, oldValue) {
        console.log(newValue, oldValue);
      },
      deep: true, // 深度监听表单
    },
  },
  created() {},
  mounted() {
    this.getProductList();
    if (!this.isLogin()) return false;
  },
  methods: {
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
    getProductList() {
      let _this = this;
      this.$toast.loading();

      let data = {
        page: _this.pageNum,
        limit: _this.pageSize,
      };
      _this.$post("/api/goods_tj_list", data, data).then((res) => {
        // console.log(res.data);
        _this.loading = false; // 加载状态结束

        if (res.data.code == 0) {
          // console.log(res.data.data);
          let lists = res.data.data;

          if (lists && lists.length > 0) {
            if (_this.pageNum == 1) {
              _this.productList = lists;
            } else {
              _this.productList = _this.productList.concat(lists);
            }
            _this.pageNum++;
            if (lists.length < _this.pageSize) {
              _this.finished = true; // 数据全部加载完成
            }
          } else {
            _this.finished = true; // 数据全部加载完成
          }
          _this.$toast.clear();
        } else {
          _this.$toast.fail(res.data.message);
          _this.finished = true;
        }
      });
    },
  },
};
</script>
  <style lang="scss" scoped>
.product-tj-page {
  padding: 50px 0;
  background-color: #f9f9f9;
  height: 100%;
  width: 100%;

  .list {
    padding: 10px;
    overflow: hidden;
  }
}
</style>
  